<template>
  <MyManage>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <template v-if="checkPermission(['bee:ict:cecCompanyInfo:getList'])">
        <el-tab-pane :label="$t('zhong-dian-lian-biao-zhun-dui-jie')" name="cec">

            <cec v-if="activeName=='cec'"></cec>

        </el-tab-pane>
      </template>

      <template v-if="checkPermission(['bee:ict:cecInterfaceName:getList'])">
        <el-tab-pane :label="$t('biao-zhun-jie-kou')" name="interfaceName">

            <interfaceName v-if="activeName=='interfaceName'"></interfaceName>

        </el-tab-pane>
      </template>


    </el-tabs>
  </MyManage>
</template>

<script>
    import MyManage from '@/components/MyManage'
    import cec from '@/module/interactionCenter/page/cec/cec/list.vue'
    import interfaceName from '@/module/interactionCenter/page/cec/interface/list.vue'

    export default {
        name: 'manage',
        components: {
            MyManage,
            cec,
            interfaceName
        },
        data() {
            return {
                activeName: 'cec'
            }
        },
        created() {
        },
        mounted() {
        },
        watch: {},
        methods: {
            handleClick(tab, event) {
                // console.log(this.activeName)
            }
        }
    }
</script>

<style type="less" scoped>
  /deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/manage.vue